import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconKeyboardDoubleArrowUpSvg } from "./IconKeyboardDoubleArrowUpSvg.mjs";
const IconKeyboardDoubleArrowUp = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconKeyboardDoubleArrowUpSvg, ...iconProps });
};
export {
  IconKeyboardDoubleArrowUp
};
